import AssignDestsTable from "./assignDests/AssignDestsTable";

const AssignProductSetsStep = () => {
  return <AssignDestsTable tableType="assignProductSets" />;
};

export default AssignProductSetsStep;
